(() => {
  'use strict';

  const CONSENT_KEY = 'fmmConsentV61';
  const BANNER_SCRIPTS = {
    mobile: 'https://www.highperformanceformat.com/b3c29c73c97166b84ba2ca46b4449c7f/invoke.js',
    rectangle: 'https://www.highperformanceformat.com/8fbde77a44e17cc9503a353736e7a4bb/invoke.js',
    leaderboard: 'https://www.highperformanceformat.com/594a3906365c6b3258047d76ea6cf601/invoke.js',
    wide: 'https://www.highperformanceformat.com/2c9a0d07a6cd314e75c3a1ef4a5f997f/invoke.js',
    rail: 'https://www.highperformanceformat.com/250998290214f3eff19f74b52fc4d38b/invoke.js',
    skyscraper: 'https://www.highperformanceformat.com/811f3a63e56e3582fe2f53d13bf18ab5/invoke.js'
  };
  const BANNER_OPTIONS = {
    mobile: { key: 'b3c29c73c97166b84ba2ca46b4449c7f', width: 320, height: 50 },
    rectangle: { key: '8fbde77a44e17cc9503a353736e7a4bb', width: 300, height: 250 },
    leaderboard: { key: '594a3906365c6b3258047d76ea6cf601', width: 728, height: 90 },
    wide: { key: '2c9a0d07a6cd314e75c3a1ef4a5f997f', width: 468, height: 60 },
    rail: { key: '250998290214f3eff19f74b52fc4d38b', width: 160, height: 300 },
    skyscraper: { key: '811f3a63e56e3582fe2f53d13bf18ab5', width: 160, height: 600 }
  };
  function pageAllowsAds() {
    return Boolean(document.querySelector('main'));
  }

  function hasConsent() {
    try {
      const value = JSON.parse(localStorage.getItem(CONSENT_KEY) || 'null');
      return value?.choice === 'all' && value.ads !== false;
    } catch {
      return false;
    }
  }

  function bannerFormat() {
    if (window.matchMedia('(max-width: 760px), (pointer: coarse)').matches) return 'mobile';
    if (document.body.matches('[data-page="project"], [data-page="creator"]') || document.querySelector('#projectDetail')) return 'rectangle';
    if (window.innerWidth >= 1280) return 'leaderboard';
    if (window.innerWidth >= 761) return 'wide';
    return 'mobile';
  }

  function createAdSlot(position) {
    const root = document.createElement('section');
    const sideClass = position === 'left' || position === 'right' ? ' fmm-adsterra-side' : '';
    root.className = `fmm-adsterra-root fmm-adsterra-${position}${sideClass} shell`;
    root.dataset.fmmAdsterraRoot = 'true';
    root.dataset.fmmAdsterraSlot = position;
    root.setAttribute('aria-label', 'Advertisement');
    root.innerHTML = '<div class="fmm-adsterra-banner" data-fmm-adsterra-banner></div>';
    return root;
  }

  function loadAd(root, requestedFormat) {
    return new Promise((resolve) => {
      try {
        const format = requestedFormat || bannerFormat();
        const options = BANNER_OPTIONS[format];
        window.atOptions = { key: options.key, format: 'iframe', height: options.height, width: options.width, params: {} };
        const frame = document.createElement('iframe');
        frame.width = String(options.width);
        frame.height = String(options.height);
        frame.title = 'Advertisement';
        frame.loading = 'lazy';
        frame.setAttribute('scrolling', 'no');
        frame.setAttribute('frameborder', '0');
        frame.dataset.fmmAdsterraFrame = format;
        frame.addEventListener('load', resolve, { once: true });
        frame.addEventListener('error', () => {
          root.classList.add('fmm-adsterra-banner-unavailable');
          resolve();
        }, { once: true });
        frame.srcdoc = `<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1"/><style>html,body{margin:0;padding:0;background:transparent;overflow:hidden}body{width:${options.width}px;min-height:${options.height}px}</style></head><body><script>window.atOptions=${JSON.stringify(window.atOptions)};</script><script data-cfasync="false" src="${BANNER_SCRIPTS[format]}"></script></body></html>`;
        root.querySelector('[data-fmm-adsterra-banner]')?.appendChild(frame);
      } catch {
        root.classList.add('fmm-adsterra-banner-unavailable');
        resolve();
      }
    });
  }

  async function renderAds() {
    if (!pageAllowsAds() || !hasConsent()) return;
    const main = document.querySelector('main');
    if (!main) return;

    const host = document.body;
    const existing = new Set([...host.querySelectorAll('[data-fmm-adsterra-slot]')].map((slot) => slot.dataset.fmmAdsterraSlot));
    const left = existing.has('left') ? host.querySelector('[data-fmm-adsterra-slot="left"]') : createAdSlot('left');
    const right = existing.has('right') ? host.querySelector('[data-fmm-adsterra-slot="right"]') : createAdSlot('right');
    const bottom = existing.has('bottom') ? host.querySelector('[data-fmm-adsterra-slot="bottom"]') : createAdSlot('bottom');
    if (!existing.has('left')) host.appendChild(left);
    if (!existing.has('right')) host.appendChild(right);
    if (!existing.has('bottom')) main.appendChild(bottom);
    if (!left.querySelector('[data-fmm-adsterra-frame]')) await loadAd(left, 'rail');
    if (!right.querySelector('[data-fmm-adsterra-frame]')) await loadAd(right, window.innerWidth >= 1500 ? 'skyscraper' : 'rail');
    if (!bottom.querySelector('[data-fmm-adsterra-frame]')) await loadAd(bottom);
  }

  function start() {
    if (!pageAllowsAds()) return;
    if (hasConsent()) renderAds();
    window.addEventListener('fmmConsentChanged', renderAds, { passive: true });
    window.addEventListener('fmm-consent-updated', renderAds, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
